import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSEO } from '../seo/seoConfig';

// Updates <head> meta tags dynamically on route change (client-side complement to pre-rendering)
const SEO = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = getSEO(pathname);
    const BASE_URL = 'https://diagnosti-k.fr';
    const canonical = seo.canonical ?? `${BASE_URL}${pathname}`;

    document.title = seo.title;

    setMeta('name', 'description', seo.description);
    setMeta('name', 'robots', 'index, follow');

    setLink('canonical', canonical);

    setMeta('property', 'og:title', seo.title);
    setMeta('property', 'og:description', seo.description);
    setMeta('property', 'og:url', canonical);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:image', seo.ogImage ?? `${BASE_URL}/image.png`);
    setMeta('property', 'og:locale', 'fr_FR');
    setMeta('property', 'og:site_name', 'DIAGNOSTI-K');

    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', seo.title);
    setMeta('name', 'twitter:description', seo.description);
    setMeta('name', 'twitter:image', seo.ogImage ?? `${BASE_URL}/image.png`);

    // JSON-LD
    const existing = document.querySelector('script[data-seo="jsonld"]');
    if (existing) existing.remove();
    if (seo.jsonLd) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.dataset.seo = 'jsonld';
      script.textContent = JSON.stringify(seo.jsonLd);
      document.head.appendChild(script);
    }
  }, [pathname]);

  return null;
};

function setMeta(attr: string, key: string, value: string) {
  let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
}

function setLink(rel: string, href: string) {
  let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
}

export default SEO;
